"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.regexp.replace");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.split");
var _axios = _interopRequireDefault(require("axios"));
var _elementUi = require("element-ui");
var _store = _interopRequireDefault(require("@/store"));
var _qs = _interopRequireDefault(require("qs"));
var _router = _interopRequireDefault(require("@/router"));
var _auth = require("@/utils/auth");
var _vue = _interopRequireDefault(require("vue"));
var _slideLogin = _interopRequireDefault(require("@/views/commonData/home/components/slideLogin.vue"));
var SlideLoginComponent = _vue.default.extend(_slideLogin.default);

// create an axios instance
var service = _axios.default.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 500000 // request timeout
});
// request interceptor
service.interceptors.request.use(function (config) {
  if (_store.default.getters.token) {
    config.headers['Authorization'] = (0, _auth.getToken)(); // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  // do something before request is sent
  if (config.method === 'get') {
    config.paramsSerializer = function (params) {
      return _qs.default.stringify(params, {
        indices: false
      });
    };
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});
var isVerifying = false;

// response interceptor
service.interceptors.response.use(
/**
 * If you want to get http information such as headers or status
 * Please return  response => response
 */

/**
 * Determine the request status by custom code
 * Here is just an example
 * You can also judge the status by HTTP Status Code
 */
function (response) {
  var res = response.data;
  if (res.errorCode && res.errorCode === 10000) {
    // to re-login
    (0, _elementUi.Message)({
      message: _store.default.state.app.language === 'zh' ? '当前连接超时,请重新登录！' : 'You have been logged out!',
      type: 'error'
    });
    _store.default.dispatch('user/resetToken').then(function () {
      location.reload(); // 重新加载本页面，跳回到登录页
    });
    return Promise.reject(new Error(res.errorMessages || 'Error'));
  } else {
    var headers = response.headers,
      config = response.config;
    if (config.responseType === 'blob' && headers) {
      res.istransfer = headers.istransfer; // 0 表示显示“索取原图”，1: 原图传输中， 2 不显示任何按钮
      res.isimage = headers.isimage;
      res.contentType = headers['content-type'];
      var contentDisposition = headers['content-disposition'];
      if (contentDisposition !== undefined) {
        try {
          res.fileName = decodeURIComponent(contentDisposition.split(';')[1].split('=')[1]);
        } catch (err) {
          res.fileName = '';
        }
      } else {
        res.fileName = '';
      }
    }
    return res; // 默认正确返回， 如需处理未登录情况，删除token后，刷新当前页
  }

  // if the custom code is not 200, it is judged as an error.

  // if (res.code !== 20000) {
  //   Message({
  //     message: res.message || 'Error',
  //     type: 'error',
  //     duration: 5 * 1000
  //   })
  //   // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
  //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
  //     // to re-login
  //     MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
  //       confirmButtonText: 'Re-Login',
  //       cancelButtonText: 'Cancel',
  //       type: 'warning'
  //     }).then(() => {
  //       store.dispatch('user/resetToken').then(() => {
  //         location.reload()
  //       })
  //     })
  //   }
  //   return Promise.reject(new Error(res.message || 'Error'))
  // } else {
  // }
}, /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(error) {
    var result, originalRequest, slideLoginInstance, modifiedRequest;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          result = error.response;
          if (!(result && result.data && result.data.code === 429)) {
            _context.next = 12;
            break;
          }
          if (!isVerifying) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return");
        case 4:
          isVerifying = true;
          originalRequest = result.config;
          slideLoginInstance = new SlideLoginComponent({
            el: document.createElement('div')
          });
          document.body.appendChild(slideLoginInstance.$el);
          slideLoginInstance.open();
          modifiedRequest = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, originalRequest), {}, {
            url: originalRequest.url.replace(/^\/api/, '') // 正则匹配开头的/api并替换为空
          });
          modifiedRequest.headers['verify-flag'] = 'T';
          return _context.abrupt("return", new Promise(function (resolve, reject) {
            slideLoginInstance.$on('verified', function () {
              slideLoginInstance.close();
              console.log('modifiedRequest', modifiedRequest);
              // 发起原始请求，将 resolve() 使用在这里
              service(modifiedRequest).then(function (response) {
                isVerifying = false; // 重置标志位
                resolve(response); // 成功通过 Promise 的流返回
              }).catch(function (error) {
                isVerifying = false; // 重置标志位
                reject(error); // 处理请求错误同样通过 Promise 返回
              });
            });
          }));
        case 12:
          if (!result) {
            _context.next = 17;
            break;
          }
          _context.next = 15;
          return resultProcess(result).then(function (res) {
            if (res.errorMessages && res.errorMessages[0] && res.errorMessages[0].includes('乐观锁')) {
              (0, _elementUi.Message)({
                message: _store.default.state.app.language === 'zh' ? '数据已被更新，请重新刷新页面' : 'The data has been updated, please refresh the page again',
                type: 'error',
                duration: 3 * 1000,
                customClass: 'zZindex'
              });
            } else {
              if (res.errorMessages && res.errorMessages.length == 1) {
                (0, _elementUi.Message)({
                  message: res.errorMessages[0],
                  type: 'error',
                  duration: 3 * 1000,
                  customClass: 'zZindex'
                });
              } else {
                (0, _elementUi.Message)({
                  message: res.errorMessages,
                  type: 'error',
                  duration: 3 * 1000,
                  customClass: 'zZindex'
                });
              }
            }
            return Promise.reject(res);
          });
        case 15:
          _context.next = 21;
          break;
        case 17:
          if (!error.includes('当前登录已过期，请重新登录')) {
            _context.next = 19;
            break;
          }
          return _context.abrupt("return");
        case 19:
          (0, _elementUi.Message)({
            message: '系统错误1222',
            type: 'error',
            duration: 3 * 1000,
            customClass: 'zZindex'
          });
          return _context.abrupt("return", Promise.reject(error));
        case 21:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());

// 错误信息处理
function resultProcess(result) {
  var data = result.data,
    config = result.config;
  var resultData = null;
  return new Promise(function (resolve, reject) {
    if (config.responseType === 'blob') {
      var reader = new FileReader();
      reader.readAsText(data, 'utf-8');
      reader.onload = function () {
        resultData = JSON.parse(reader.result);
        resolve(resultData);
      };
    } else {
      resolve(result.data);
    }
  });
}
var alertFun = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
    var confirmElements, languageFlag;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          confirmElements = window.document.getElementsByClassName('el-message-box__wrapper');
          if (!(confirmElements.length === 0 || confirmElements.length > 0 && confirmElements[0].style.display === 'none' || confirmElements.length > 0 && confirmElements[0].style.display !== 'none' && confirmElements[0].firstElementChild.className.indexOf('expiredTag') === -1)) {
            _context3.next = 5;
            break;
          }
          languageFlag = _store.default.state.app.language === 'zh';
          _context3.next = 5;
          return _elementUi.MessageBox.alert(languageFlag ? '当前登录已过期，请重新登录。' : 'The current login has expired. Please log in again.', languageFlag ? '提示' : 'Hint', {
            customClass: 'expiredTag',
            distinguishCancelAndClose: true,
            confirmButtonText: languageFlag ? '确定' : 'Confirm'
          }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
            return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _store.default.dispatch('user/logout');
                case 2:
                  _router.default.push('/login');
                case 3:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }))).catch(function () {});
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function alertFun() {
    return _ref2.apply(this, arguments);
  };
}();
var _default = exports.default = service;